import { render, staticRenderFns } from "./CellRendererContentClass.vue?vue&type=template&id=0f56aec5&scoped=true"
import script from "./CellRendererContentClass.vue?vue&type=script&lang=js"
export * from "./CellRendererContentClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f56aec5",
  null
  
)

export default component.exports